import { AxiosError } from 'axios';
import { left, right } from '../../../../shared/core/Either';
import { Result } from '../../../../shared/core/Result';
import { APIResponse } from '../../../../shared/infra/api/APIResponse';
import { BaseAPI } from '../../../../shared/infra/api/BaseAPI';
import { IAuthService } from '../../../users/services/authService';
import { UpdateContactPermissionRequestDTO } from '../infra';

export interface ISettingsService {
  updateContactPermissions(
    request: UpdateContactPermissionRequestDTO,
  ): Promise<APIResponse<void>>;
}

export class SettingsService extends BaseAPI implements ISettingsService {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  protected onFailureExecuteImpl(error: AxiosError<any>): Promise<any> {
    throw new Error('Method not implemented.');
  }

  constructor(authService: IAuthService) {
    super(authService);
  }

  hasToken(): boolean {
    return this.authService.isUserAuthenticated();
  }

  async updateContactPermissions(
    request: UpdateContactPermissionRequestDTO,
  ): Promise<APIResponse<void>> {
    try {
      await this.patch<UpdateContactPermissionRequestDTO>({
        url: '/v1/community/contact/permission',
        requiresToken: true,
        payload: request,
      });

      return right(Result.ok<void>());
    } catch (err: any) {
      return left(err.response ? err.response.data : 'Connecton failed');
    }
  }
}
